import { lazy } from "react";

export const DoctorsAsync = lazy(() => import("./Doctors"));
